module.exports = __webpack_public_path__ + "img/0.b385278b.png";